import qs from 'querystringify'
import { NewOrder, UpdateOrder, OrderPay, Order, SearchOrdersParams, OrderEmail } from './types'
import { Base, Response } from '../base'

const resourceName = 'orders'

export class Orders extends Base {
    getOrders(params?: SearchOrdersParams) {
        let query = `${resourceName}`
        if (params) {
            query += qs.stringify(params, '?')
        }
        return this.request<Order[]>(query)
    }

    getSecuredOrder(id: string) {
        return this.request<Order>(`${resourceName}/${id}`)
    }

    getOrder(id: string) {
        return this.request<Order>(`app/${resourceName}/${id}`)
    }

    createOrder(params: NewOrder) {
        return this.request<Response<Order>>(`app/${resourceName}`, {
            method: 'POST',
            body: JSON.stringify({ ...params })
        })
    }

    payOrder(params: OrderPay) {
        return this.request<Response<Order>>(`app/${resourceName}/pay`, {
            method: 'POST',
            body: JSON.stringify({ ...params })
        })
    }

    sendOrderReciepMail(id: number,params: OrderEmail) {
        return this.request<Response<String>>(`app/${resourceName}/send-reciept/${id}`, {
            method: 'POST',
            body: JSON.stringify({ ...params })
        })
    }

    sendSimpleOrderReceiptMail(id: number,params: OrderEmail) {
        return this.request<Response<String>>(`app/${resourceName}/send-order-receipt/${id}`, {
            method: 'POST',
            body: JSON.stringify({ ...params })
        })
    }

    getOrderReciepTemplate(id: number) {
        return this.request<Response<String>>(`app/${resourceName}/download-reciept/${id}`)
    }

    getSimpleOrderReceiptTemplate(id: number) {
        return this.request<Response<String>>(`app/${resourceName}/download-order-receipt/${id}`)
    }

    updateOrder(id: number, params?: UpdateOrder) {
        return this.request<Response<Order>>(`app/${resourceName}/${id}`, {
            method: 'PUT',
            body: JSON.stringify({ ...params })
        })
    }

    /*deleteOrder (id: string) {
        return this.request<Order>(`${resourceName}/${id}`, { method: 'DELETE' })
    }*/

}
